/**
 * Daily quote in the top bar (stable per calendar day).
 * Quotes loaded from assets/top-bar-quotes.json (URL via data-quotes-url).
 */
(function () {
  var el = document.getElementById("top-bar-daily-quote");
  if (!el) return;

  var script =
    document.currentScript ||
    document.querySelector('script[src*="top-bar-daily-quote"]');
  var url = (script && script.getAttribute("data-quotes-url")) || "";
  if (!url) return;

  function indexForDay(len) {
    if (!len) return 0;
    var days = Math.floor(Date.now() / 86400000);
    return ((days % len) + len) % len;
  }

  function showQuote(text) {
    if (!text) return;
    el.textContent = String(text).trim();
    el.removeAttribute("hidden");
  }

  fetch(url, { credentials: "same-origin" })
    .then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    })
    .then(function (quotes) {
      if (!Array.isArray(quotes) || !quotes.length) return;
      var q = quotes[indexForDay(quotes.length)];
      if (typeof q === "string") showQuote(q);
      else if (q && q.text) {
        showQuote(q.author ? q.text + " — " + q.author : q.text);
      }
    })
    .catch(function () {});
})();
